import service from '@/utils/server';

const modName='/report/zpcBoxReportForm/';
//查询方法
export const pageInfo = data => {
  console.log('pageInfo', '-----');
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//新增方法
export const saveData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};

//修改方法
export const editData = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};

//删除方法
export const deleteData = data => {
  return service({
    url: modName + 'delete/'+data.id,
    method: 'post',
    data
  });
};
//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};
//查询
export const selectOrderNoList = data =>{
  return service({
    url: modName + 'selectOrderNoList',
    method: 'post',
    data
  })
};
//查询
export const selectRfidList = data =>{
  return service({
    url: modName + 'selectRfidList',
    method: 'post',
    data
  })
};
//查询
export const selectThirdCustomerNameList = data =>{
  return service({
    url: modName + 'selectThirdCustomerNameList',
    method: 'post',
    data
  })
};
//查询
export const selectPackerCodeList = data =>{
  return service({
    url: modName + 'selectPackerCodeList',
    method: 'post',
    data
  })
};
//查询
export const selectItrCodeList = data =>{
  return service({
    url: modName + 'selectItrCodeList',
    method: 'post',
    data
  })
};
//查询
export const selectSkuList = data =>{
  return service({
    url: modName + 'selectSkuList',
    method: 'post',
    data
  })
};
//查询
export const selectPackerNameList = data =>{
  return service({
    url: modName + 'selectPackerNameList',
    method: 'post',
    data
  })
};





// WEBPACK FOOTER //
// ./src/page/report/boxReportForm/api/index.js